import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import FilterButton from 'components/common/Filters/FilterButton'
import { FilterFacet } from 'components/common/Filters/FilterGroup'
import Media from 'components/common/Media'
import CompatibilityForm from '../CompatibilityForm'

const BrandGuidedNavigation = ({
  compatibilityFilter,
  hasActiveVehicle,
  showFilterModal,
  placeholders: { navigation = []} = {},
  navigation: items,
  updateQuery
}) =>
  <Fragment>
    <Media.Desktop>
      {
        React.Children.map(navigation, (component, index) =>
          React.cloneElement(component, { key: items[index].displayName }))
      }
      {
        hasActiveVehicle &&
          <FilterFacet title="Compatibility" expandedByDefault={ Boolean(compatibilityFilter) } preventHandleBlur>
            <CompatibilityForm compatibilityFilter={ compatibilityFilter } handleChange={ updateQuery } />
          </FilterFacet>
      }
    </Media.Desktop>
    <Media.Mobile>
      <FilterButton title="Filter results" onClick={ showFilterModal } />
    </Media.Mobile>
  </Fragment>

export default BrandGuidedNavigation

BrandGuidedNavigation.propTypes = {
  compatibilityFilter: PropTypes.string,
  hasActiveVehicle: PropTypes.bool,
  navigation: PropTypes.arrayOf(PropTypes.object),
  placeholders: PropTypes.shape({
    navigation: PropTypes.array
  }),
  showFilterModal: PropTypes.func,
  updateQuery: PropTypes.func
}
